import mainAPI from '../api/MainAPI';
import toasts from '../utils/toasts';
import { wasteDrugDetailsRoute } from '../components/pages/wasteDrugDetailsPage/WasteDrugDetailsPage';
import BatchWasteOptionPopup from '../components/popups/batchWasteOptionPopup/BatchWasteOptionPopup';
import batchWasteController from './batchWasteController';
import gramUtils from '../utils/gramUtils';
import getLocation, { getLastLocation } from '../utils/getLocation';
import models from '../model/models';
import resealController from './resealController';
import dashboardController from "./dashboardController";

const WasteController = function () {
	this.sending = false;
	this.drug = null;
	this.start = (drug, drug_box_id) => {
		this.reset();
		this.drug = drug;
		this.drug_box_id = drug_box_id;
		getLocation();
		window.popupController.show(BatchWasteOptionPopup, {
			onYesAddMore: this._startBatchWaste,
			onNoWasteOne: this._wasteDrugDetails
		});
	};

	this._startBatchWaste = async () => {
		batchWasteController.start(this.drug, this.drug_box_id);
		this.reset();
	};

	this._wasteDrugDetails = async () => {
		const drugDetails = await mainAPI.drug.get(this.drug.id);
		window.f7.views.current.router.navigate(wasteDrugDetailsRoute, {
			props: {
				id: this.drug.id,
				quantity: drugDetails.stock_move_record__quantity,
				drugDetails,
				onComplete: this._wasteDrug
			}
		});
	};

	this.reset = () => {
		this.sending = false;
		this.drug = null;
	};

	this._wasteDrug = async (verifier, notes, quantityFromInput, reverseDistributor) => {
		const success = await wasteDrug(
			verifier,
			notes,
			quantityFromInput,
			this.drug.type,
			this.drug.id,
			reverseDistributor,
			this.drug_box_id
		);
		if (!success) return false;
		const drugType = models.drug_type.obj(this.drug.type);

		toasts.show(`${drugType.name} wasted`);
		this._resealDrugBox(this.drug.id).catch(console.error);
		this.reset();
		return success;
	};

	this._resealDrugBox = async (drug_id) => {
		const user_group = models.user_group.obj();
		const drug = await mainAPI.drug.get(drug_id);
		let box = models.drug_box.obj(drug.drug_box_id);
		if(canSkipReseal(user_group, box)) return;
		resealController.foundBox(box, null);
	};
};

export const canSkipReseal = (user_group, box) => {
	if (!user_group.usage_requires_reseal && box.unit__type !== 'supply') return true;
	if (!user_group.usage_requires_reseal_supply && box.unit__type === 'supply') return true;
	return false;
};

export const wasteDrug = async (verifier, notes, quantityFromInput, drugType, drugId, reverseDistributor, drugBoxId) => {
	let optionalProperties = {};
	if (quantityFromInput) {
		const quantity = -Math.abs(quantityFromInput); // force negative
		if (quantity) {
			optionalProperties.quantity = gramUtils.toMicrograms(quantity, drugType);
		} else {
			optionalProperties.waste_all = 1;
		}
	} else {
		optionalProperties.waste_all = 1;
	}

	let location = getLastLocation();
	let stockMoveRecord = {
		stock_move_type_id__name: 'waste',
		drug_id: drugId,
		...optionalProperties,
		witness_id: verifier.witness_id,
		witness_biometric_guid: verifier.guid,
		guest_verify__license_number: verifier.guest_verify__license_number,
		guest_verify__name: verifier.guest_verify__name,
		guest_verify__signature_img: verifier.guest_verify__signature_img,
		guest_verify__title: verifier.guest_verify__title,
		notes,
		lat: location.lat,
		lon: location.lon
	};
	if (reverseDistributor) {
		stockMoveRecord.reverse_distributor = reverseDistributor;
	}
	const success = await mainAPI.stock_move_record.create(stockMoveRecord);
	if (!success) {
		toasts.error('Something went wrong');
		mainAPI.error_log.create({
			type: 'wasteController failed',
			message: 'failed to create' + JSON.stringify(stockMoveRecord)
		});
	}
	dashboardController.refreshThrottled(drugBoxId);
	return success;
};
const wasteController = new WasteController();

export default wasteController;
